import { render, staticRenderFns } from "./NoGo.vue?vue&type=template&id=32d0094c"
import script from "./NoGo.vue?vue&type=script&lang=ts"
export * from "./NoGo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports